<template>
  <div class="signin">
    <adx-modal @modal-close="toggleModal" :type="`account`" :title="`Sign in`">
      <div slot="content" class="content">
        <div class="content__header">
          <div class="content__header--title">
            <adx-alert :duration="100000" :classes="'style'" :isClose="true" :group="'account'" />
            <!-- <h2 class="medium-title">Sign in</h2> -->
          </div>
        </div>
        <div class="content__mediasocial">
          <button class="btn-block not-rounded facebook" @click="socialLogin(`facebook`, currentRoute)">
            <i class="adx-ic_facebook"></i>
            Sign in with Faceboook
          </button>
          <button class="btn-block not-rounded secondary google" @click="socialLogin(`google`, currentRoute)">
            <i class="adx-ic_google"></i>
            Sign in with Google
          </button>
        </div>
        <div class="content__divider">
          <span></span>
          <div class="or">OR</div>
          <span></span>
        </div>
        <div class="content__input">
          <adx-form
            @complete="complete"
            @error400="error400"
            @goto="goto"
            :formType="'login'"
            :schema="schema"
            :model.sync="model"
            :error.sync="error"
            :onSubmit="onSubmit"
            :wrapper="wrapper" />
        </div>
        <div class="content__fulldivider">

        </div>
        <div class="content__footer">
          <div class="signup">
            Don’t have an account ? <span @click.stop="goToSignUp">Sign up</span>
          </div>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import Vue from "vue";

import Modal from '@/components/Modal'
import Input from '@/components/Form/Input'
import Checkbox from '@/components/Form/Checkbox'
import FormAbstraction from '@/components/Form'
import Alert from "@/components/Alert"

import api from '@/api'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import types from '@/lib/types'
import { apiV2 } from '@/api/urls'

import { authMixin } from '@/lib/mixins/authMixin'

const {
  ButtonType: { BUTTON, RESET },
  ButtonAction: { SUBMIT, APICALL, GOTO }
} = types

export default {
  name: 'adx-signin-modal',
  components: {
    'adx-modal': Modal,
    'adx-input': Input,
    'adx-checkbox': Checkbox,
    'adx-form': FormAbstraction,
    'adx-alert': Alert,
  },
  mixins: [ authMixin ],
  props: {

  },
  data() {
    return {
      wrapper: {
        alertWrapper: `content`
      },
      model: {
        email: ``,
        password: ``,
        next: ``
      },
      error: {
        email: ``,
        password: ``,
      },
      onSubmit: {
        wrapper: {
          class: ``
        },
        buttons: [
          {
            type: BUTTON,
            action: SUBMIT,
            label: `Sign in`,
            uri: apiV2.signin,
            params: this.model,
            method: `post`, // HTTP Method
            class: `btn-block primary signin not-rounded`,
            isLoading: false
          },
        ]
      },
      schema: [
        {
          type: 'hidden',
          fields: [
            {
              type: 'input',
              inputType: 'hidden',
              model: 'next'
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Email',
              model: 'email',
              method: 'onChange',
              validation: ['Email', 'NotEmpty']
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'password',
              label: 'Password',
              model: 'password',
              method: 'onChange',
              validation: ['NotEmpty']
            }
          ]
        },
        {
          type: 'flex__right',
          fields: [
            {
              type: 'link',
              label: 'Forgot Password',
              to: 'forgot-password',
              event: 'gotoforgot'
            }
          ]
        },
      ]
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    const { next } = this.$route.query
    if (next) {
      this.model.next = next
    }
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    goto(name){
      if(name == 'gotoforgot'){
        this.openForgot()
      }
    },
    toggleModal() {
      this.$emit('toggle', 'toggleSignin')
    },
    goToSignUp() {
      this.$emit('toggle', 'gotoSignup')
    },
    openForgot() {
      this.$emit('toggle', 'gotoForgotFromSignin')
    },
    complete($event) {
      (async () => {
        const response  = await this.$store.dispatch('getAccount', $event.args.data)
        await this.$store.dispatch(`setProfile`)
        this.toggleModal()
        // this.$router.push({path: $event.args.data.redirect_to})
        window.location = $event.args.data.redirect_to
      })();
    },
    error400($event) {
      const { redirect_to, message, ...response } = $event.data
      if (redirect_to) {
        this.toggleModal()
        this.$router.push(redirect_to)
      } else {
        if (message === 'with_social_login') {
          this.$emit('toggle', 'gotoSocialFromSignin', response)
        }
      }
    },

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>